import type { ReactElement } from 'react';
import type { CustomForm } from './formMapTypes';

type Field = {
  constraints: any;
  defaultValue: Nullable<string>;
  id: string;
  label: string;
  properties: Nullable<string>;
  type: string;
  values: Nullable<{}[]>;
};

export enum RequestType {
  TYPE_TASK_TRACKER_ISSUE = 'task_tracker_issue',
  TYPE_PROCESS = 'process',
  TYPE_FORM = 'form',
}

export type Request = {
  description: string;
  fields: Nullable<Field[]>;
  form: Nullable<CustomForm>;
  id: string;
  type?: RequestType;
  section: string;
  shortDescription: Nullable<string>;
  title: string;
  validationSchema: Nullable<{}[]>;
  sectionTitle?: string;
};

export type FilterSection = {
  id: string;
  title: string;
  icon: Nullable<ReactElement>;
  items?: Request[];
};
